import {WarrantyTypes} from '../services/warranty.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {QuotationActions} from './quotation-list-info.model';
import {PartsType} from './enums.model';

// CAR BODY
export class CarBodyQuotationDetail {
	id: string;
	entries: CarBodyQuotationEntry[];
	key: CarBodyQuotationKey;
	summary: CarBodyQuotationSummary;
	//moved to summary - Rug
	// summaryParameters: QuotationSummaryParameters;
	actions: QuotationActions;
	total_charge: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.id = model.id;
			this.total_charge = model.total_charge;
			this.entries = [];
			model.entries = Utilities.isEmpty(model.entries) ? [] : model.entries;
			model.entries = model.entries
				.sort((entry1, entry2) => {
					if (entry1.type === PartsType.KIT && entry2.type !== PartsType.KIT) {
						return -1;
					}
					if (entry1.type !== PartsType.KIT && entry2.type === PartsType.KIT) {
						return 1;
					}
					return 0;
				});
			model.entries.forEach(item => {
				if (item.type === PartsType.KIT) {
					this.entries.push(new CarBodyQuotationEntry(item));
					model.entries.filter(entry => entry.parent_id === item.part_id).forEach(entry => {
						this.entries.push(new CarBodyQuotationEntry(entry));
						model.entries.splice(model.entries.indexOf(entry), 1);
					});
				} else {
					this.entries.push(new CarBodyQuotationEntry(item));
				}
			});
			this.key = new CarBodyQuotationKey (model.key);
			this.summary = new CarBodyQuotationSummary (model.summary);
			//moved to summary - Rug
			//this.summaryParameters = new QuotationSummaryParameters(model.summary_parameter);
			this.actions = new QuotationActions (model.actions);
		}
	}
	
	/**
	 * Converte un oggetto preventivo carrozzeria in un DTO
	 * @param {CarBodyQuotationDetail} quotation
	 * @returns {any}
	 */ 
	object2DTO(quotation: CarBodyQuotationDetail): any {
		return {
			id					 : quotation.id,
			total_charge : quotation.total_charge,
			key					 : quotation.key.object2DTO(quotation.key),
			summary			 : quotation.summary.object2DTO(quotation.summary),
			actions			 : quotation.actions.object2DTO(quotation.actions),
			entries			 : quotation.entries.map((x: CarBodyQuotationEntry) => x.object2DTO(x)),
		};
	}
}

export class CarBodyQuotationEntry {
	arrivedAt: string;
	accidentPartRight: string;
	amount: number;
	brand: string;
	brandLabel: string;
	categorical: string;
	dealerId: string;
	description: string;
	discount: number;
	discountExtra: number;
	entryType: string;
	entryStatus: string;
	frequencyHandling: string;
	id: string;
	levelSr: string;
	levelLa: string;
	levelVe: string;
	manHourHours: number;
	partCode: string;
	partCost: number;
	partId: string;
	partType: string;
	rotation: string;
	shippingDate: string;
	timeLa: number;
	timeMe: number;
	timeSr: number;
	timeVe: number;
	totalPartValue: number;
	vat: number;
	vatFree: true;
	warrantyType: WarrantyTypes;
	isForDealer: boolean;
	isNew: boolean;
	note: string;
	billable: string;
	isForConsip: boolean;
	extraFeeRecalculatedPrice: number;
	partNumber: string;
	extraFeeStartingPrice: number;
	extraFeeDiscountPercentage: number;
	originalPartNumber: string;
	partsCategory: string;
	elapsedOrderIds: string[] = [];
	parent_id?: string;
	type?: PartsType;
	dealer_handler?: boolean;
	is_approved?: boolean;
	recharge_to?: string;
	is_arrived_or_not_available: boolean;
	total_taxable_assistance_center: number;
	total_with_vat_assistance_center: number;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.accidentPartRight = model.accident_part_right;
			this.amount = model.amount;
			this.brand = model.brand;
			this.categorical = model.categorical;
			this.dealerId = model.dealer_id;
			this.description = model.description;
			this.discount = model.discount;
			this.discountExtra = model.discount_extra;
			this.entryType = model.entry_type;
			this.entryStatus = model.entry_status;
			this.frequencyHandling = model.frequency_handling;
			this.id = model.id;
			this.levelSr = model.level_sr;
			this.levelLa = model.level_la;
			this.levelVe = model.level_ve;
			this.manHourHours = model.man_hour_hours;
			this.partCode = model.part_code;
			this.partCost = model.part_cost;
			this.partId = model.part_id;
			this.partType = model.part_type;
			this.rotation = model.rotation;
			this.timeLa = model.time_la;
			this.timeMe = model.time_me;
			this.timeSr = model.time_sr;
			this.timeVe = model.time_ve;
			this.totalPartValue = model.total_part_value;
			this.vat = model.vat;
			this.vatFree = model.vat_free;
			this.warrantyType = model.warranty_type;
			this.isForDealer = model.is_for_dealer;
			this.isNew = model.is_new;
			this.shippingDate = model.shipping_date;
			this.note = model.note;
			this.arrivedAt = model.arrived_at;
			this.billable = model.billable;
			this.isForConsip = model.is_for_consip;
			this.extraFeeRecalculatedPrice = model.extra_fee_recalculated_price;
			this.partNumber = model.part_number;
			this.brandLabel = model.brand_label;
			this.extraFeeStartingPrice = model.extra_fee_starting_price;
			this.extraFeeDiscountPercentage = model.extra_fee_discount_percentage;
			this.originalPartNumber = model.original_part_number;
			this.partsCategory = model.parts_category;
			this.elapsedOrderIds = [];
			this.parent_id = model.parent_id;
			this.type = model.type;
			this.dealer_handler = model.dealer_handler;
			this.is_approved = model.is_approved;
			this.recharge_to = model.recharge_to;
			if (model.elapsed_order_ids) {
				model.elapsed_order_ids.forEach(id => {
					this.elapsedOrderIds.push(id);
				});
			}
			this.is_arrived_or_not_available = model.is_arrived_or_not_available;
			
			this.total_with_vat_assistance_center = model.total_with_vat_assistance_center;
			this.total_taxable_assistance_center = model.total_taxable_assistance_center;
		}
	}
	
	/**
	 * Converte un oggetto entry preventivo in un DTO
	 * @param {CarBodyQuotationEntry} entry
	 * @returns {any}
	 */ 
	object2DTO(entry: CarBodyQuotationEntry): any {
		return {
			accident_part_right 						 : entry.accidentPartRight,
			amount 													 : entry.amount,
			brand 													 : entry.brand,
			categorical 										 : entry.categorical,
			dealer_id 											 : entry.dealerId,
			description 										 : entry.description,
			discount 												 : entry.discount,
			discount_extra 									 : entry.discountExtra,
			entry_type 											 : entry.entryType,
			entry_status 										 : entry.entryStatus,
			frequency_handling 							 : entry.frequencyHandling,
			id 															 : entry.id,
			level_sr 												 : entry.levelSr,
			level_la 												 : entry.levelLa,
			level_ve 												 : entry.levelVe,
			man_hour_hours 									 : entry.manHourHours,
			part_code 											 : entry.partCode,
			part_cost 											 : entry.partCost,
			part_id 												 : entry.partId,
			part_type 											 : entry.partType,
			rotation 												 : entry.rotation,
			time_la 												 : entry.timeLa,
			time_me 												 : entry.timeMe,
			time_sr 												 : entry.timeSr,
			time_ve 												 : entry.timeVe,
			total_part_value 								 : entry.totalPartValue,
			vat 														 : entry.vat,
			vat_free 												 : entry.vatFree,
			warranty_type 									 : entry.warrantyType,
			is_for_dealer 									 : entry.isForDealer,
			is_new 													 : entry.isNew,
			shipping_date 									 : entry.shippingDate,
			note 														 : entry.note,
			arrived_at 											 : entry.arrivedAt,
			billable 												 : entry.billable,
			is_for_consip 									 : entry.isForConsip,
			extra_fee_recalculated_price 		 : entry.extraFeeRecalculatedPrice,
			part_number 										 : entry.partNumber,
			brand_label 										 : entry.brandLabel,
			extra_fee_starting_price 				 : entry.extraFeeStartingPrice,
			extra_fee_discount_percentage 	 : entry.extraFeeDiscountPercentage,
			original_part_number 						 : entry.originalPartNumber,
			parts_category 									 : entry.partsCategory,
			parent_id 											 : entry.parent_id,
			type 														 : entry.type,
			dealer_handler 									 : entry.dealer_handler,
			is_approved 										 : entry.is_approved,
			recharge_to 										 : entry.recharge_to,
			is_arrived_or_not_available 		 : entry.is_arrived_or_not_available,
			total_with_vat_assistance_center : entry.total_with_vat_assistance_center,
			total_taxable_assistance_center  : entry.total_taxable_assistance_center,		
			elapsed_order_ids  							 :	entry.elapsedOrderIds,		
		}
	}
}

class CarBodyQuotationKey {
	accidentNumberOut: string;
	actualUser: string;
	externalQuotationId: string;
	messageId: string;
	quotationVersion: string;
	userOwner: string;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.accidentNumberOut = model.accident_number_out;
			this.actualUser = model.accident_number_out;
			this.externalQuotationId = model.accident_number_out;
			this.messageId = model.accident_number_out;
			this.quotationVersion = model.accident_number_out;
			this.userOwner = model.accident_number_out;
		}
	} 
	
	/**
	 * Converte un oggetto chiavi preventivo in un DTO
	 * @param {CarBodyQuotationKey} quotation
	 * @returns {any}
	 */ 
	object2DTO(key: CarBodyQuotationKey): any {
		return {
			accident_number_out		: key.accidentNumberOut,
			message_id						: key.messageId,
			external_quotation_id	: key.externalQuotationId,
			quotation_version			: key.quotationVersion,
			user_owner						: key.userOwner,
			actual_user						: key.actualUser,
		};
	}
}

export class CarBodyQuotationSummary {
	consumablesValueVe: number;
	doubleLayerSupplement: number;
	entries: SummaryQuotationEntry[];
	finishingSupplement: number;
	fixedConsumablesValue: number;
	paintPreparation: number;
	total: QuotationSummaryTotal;
	totalHourLa: number;
	totalHourManpower: number;
	totalHourMe: number;
	totalHourSr: number;
	totalHourVe: number;
	hourlyCostLa: number;
	hourlyCostSr: number;
	hourlyCostVe: number;
	hourlyCostMe: number;
	totalHourWithSupplementsVe: number;
	totalManpowerTaxable: number;
	extraFeeTotal: number;
	extraFeeTotalWithVat: number;
	extraFeeVatTax: number;
	extraFeeSparePartsTotal: number;
	vatQuotationPercentage: number;
	totalSparePartsTaxableAssistanceCenter: number;
	totalTaxableAssistanceCenter: number;
	totalVatAssistanceCenter: number;
	totalWithVatAssistanceCenter: number;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.consumablesValueVe = model.consumables_value_ve;
			this.doubleLayerSupplement = model.double_layer_supplement;
			this.entries = [];
			model.entries.forEach (item => this.entries.push (new SummaryQuotationEntry (item)));
			this.finishingSupplement = model.finishing_supplement;
			this.fixedConsumablesValue = model.fixed_consumables_value;
			this.paintPreparation = model.paint_preparation;
			this.total = new QuotationSummaryTotal (model.total);
			this.totalHourLa = model.total_hour_la;
			this.totalHourManpower = model.total_hour_manpower;
			this.totalHourMe = model.total_hour_me;
			this.totalHourSr = model.total_hour_sr;
			this.totalHourVe = model.total_hour_ve;
			this.hourlyCostLa = model.hourly_cost_la;
			this.hourlyCostSr = model.hourly_cost_sr;
			this.hourlyCostVe = model.hourly_cost_ve;
			this.hourlyCostMe = model.hourly_cost_me;
			this.totalHourWithSupplementsVe = model.total_hour_with_supplements_ve;
			this.totalManpowerTaxable = model.total_manpower_taxable;
			this.extraFeeTotal = model.extra_fee_total;
			this.extraFeeTotalWithVat = model.extra_fee_total_with_vat;
			this.extraFeeVatTax = model.extra_fee_vat_tax;
			this.extraFeeSparePartsTotal = model.extra_fee_spare_parts_total;
			this.vatQuotationPercentage = model.vat_quotation_percentage;
			this.totalSparePartsTaxableAssistanceCenter = model.total_spare_parts_taxable_assistance_center;
			this.totalTaxableAssistanceCenter = model.total_taxable_assistance_center;
			this.totalVatAssistanceCenter = model.total_vat_assistance_center;
			this.totalWithVatAssistanceCenter = model.total_with_vat_assistance_center;
		}
	}

	/**
	 * Converte un oggetto summary carrozzeria in un DTO
	 * @param {CarBodyQuotationSummary} summary
	 * @returns {any}
	 */ 
	object2DTO(summary: CarBodyQuotationSummary): any {
		return {
			consumables_value_ve												: summary.consumablesValueVe,
			double_layer_supplement											: summary.doubleLayerSupplement,
			finishing_supplement												: summary.finishingSupplement,
			fixed_consumables_value											: summary.fixedConsumablesValue,
			paint_preparation														: summary.paintPreparation,
			total_hour_la																: summary.totalHourLa,
			total_hour_manpower													: summary.totalHourManpower,
			total_hour_me																: summary.totalHourMe,
			total_hour_sr																: summary.totalHourSr,
			total_hour_ve																: summary.totalHourVe,
			hourly_cost_la															: summary.hourlyCostLa,
			hourly_cost_sr															: summary.hourlyCostSr,
			hourly_cost_ve															: summary.hourlyCostVe,
			hourly_cost_me															: summary.hourlyCostMe,
			total_hour_with_supplements_ve							: summary.totalHourWithSupplementsVe,
			total_manpower_taxable											: summary.totalManpowerTaxable,
			extra_fee_total															: summary.extraFeeTotal,
			extra_fee_total_with_vat										: summary.extraFeeTotalWithVat,
			extra_fee_vat_tax														: summary.extraFeeVatTax,
			extra_fee_spare_parts_total									: summary.extraFeeSparePartsTotal,
			vat_quotation_percentage										: summary.vatQuotationPercentage,
			total_spare_parts_taxable_assistance_center	: summary.totalSparePartsTaxableAssistanceCenter,
			total_taxable_assistance_center							: summary.totalTaxableAssistanceCenter,
			total_vat_assistance_center									: summary.totalVatAssistanceCenter,
			total_with_vat_assistance_center						: summary.totalWithVatAssistanceCenter,
			
			total : summary.total.object2DTO(summary.total),
			entries : Utilities.isEmpty(summary.entries) ? [] : summary.entries.map((x: SummaryQuotationEntry) => x.object2DTO(x)),
		}
	}
}


// MECHANIC
export class MechanicQuotationDetail {
	id: string;
	entries: MechanicQuotationEntry[];
	externalId: string;
	interventionId: string;
	portal: string;
	summary: MechanicQuotationSummary;
	//moved to summary - Rug
	//summaryParameters: QuotationSummaryParameters;
	actions: QuotationActions;
	total_charge: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.id = model.id;
			this.total_charge = model.total_charge;
			this.entries = [];
			model.entries = Utilities.isEmpty(model.entries) ? [] : model.entries;
			model.entries = model.entries
				.sort((entry1, entry2) => {
					if (entry1.type === PartsType.KIT && entry2.type !== PartsType.KIT) {
						return -1;
					}
					if (entry1.type !== PartsType.KIT && entry2.type === PartsType.KIT) {
						return 1;
					}
					return 0;
				});
			model.entries.forEach(item => {
				if (item.type === PartsType.KIT) {
					this.entries.push(new MechanicQuotationEntry(item));
					model.entries.filter(entry => entry.parent_id === item.part_id).forEach(entry => {
						this.entries.push(new MechanicQuotationEntry(entry));
						model.entries.splice(model.entries.indexOf(entry), 1);
					});
				} else {
					this.entries.push(new MechanicQuotationEntry(item));
				}
			});
			this.externalId = model.external_id;
			this.interventionId = model.intervention_id;
			this.portal = model.portal;
			this.summary = new MechanicQuotationSummary (model.summary);
			//moved to summary - Rug
			//this.summaryParameters = new QuotationSummaryParameters(model.summary_parameters);
			this.actions = new QuotationActions (model.actions);
		}
	}

	/**
	 * Converte un oggetto preventivo meccanica in un DTO
	 * @param {MechanicQuotationDetail} quotation
	 * @returns {any}
	 */ 
	object2DTO(quotation: MechanicQuotationDetail): any {	
		return {
			id								: quotation.id,
			externalId				: quotation.externalId,
			interventionId		: quotation.interventionId,
			total_charge			: quotation.total_charge,
			portal						: quotation.portal,
			summary						: quotation.summary.object2DTO(quotation.summary),
			actions						: quotation.actions.object2DTO(quotation.actions),
			entries						: quotation.entries.map((x: MechanicQuotationEntry) => x.object2DTO(x)),
		}
	}
}

export class MechanicQuotationEntry {
	arrivedAt: string;
	accidentPartRight: string;
	amount: number;
	brand: string;
	brandLabel: string;
	categorical: string;
	dealerId: string;
	description: string;
	discount: number;
	discountExtra: number;
	entryType: string;
	entryStatus: string;
	frequencyHandling: string;
	id: string;
	manHourHours: number;
	partCode: string;
	partCost: number;
	partId: string;
	partType: string;
	rotation: string;
	totalPartValue: string;
	shippingDate: string;
	vat: number;
	vatFree: boolean;
	warrantyType: WarrantyTypes;
	isForDealer: boolean;
	isNew: boolean;
	note: string;
	isForConsip: boolean;
	extraFeeRecalculatedPrice: number;
	partNumber: string;
	extraFeeStartingPrice: number;
	extraFeeDiscountPercentage: number;
	originalPartNumber: string;
	elapsedOrderIds: string[] = [];
	parent_id?: string;
	type?: PartsType;
	dealer_handler?: boolean;
	is_approved?: boolean;
	recharge_to?: string;
	is_arrived_or_not_available: boolean;
	total_taxable_assistance_center: number;
	total_with_vat_assistance_center: number;


	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.accidentPartRight = model.accident_part_right;
			this.amount = model.amount;
			this.brand = model.brand;
			this.categorical = model.categorical;
			this.dealerId = model.dealer_id;
			this.description = model.description;
			this.discount = model.discount;
			this.discountExtra = model.discount_extra;
			this.entryType = model.entry_type;
			this.entryStatus = model.entry_status;
			this.frequencyHandling = model.frequency_handling;
			this.id = model.id;
			this.manHourHours = model.man_hour_hours;
			this.partCode = model.part_code;
			this.partCost = model.part_cost;
			this.partId = model.part_id;
			this.partType = model.part_type;
			this.rotation = model.rotation;
			this.totalPartValue = model.total_part_value;
			this.vat = model.vat;
			this.vatFree = model.vat_free;
			this.warrantyType = model.warranty_type;
			this.isForDealer = model.is_for_dealer;
			this.isNew = model.is_new;
			this.shippingDate = model.shipping_date;
			this.note = model.note;
			this.arrivedAt = model.arrived_at;
			this.isForConsip = model.is_for_consip;
			this.extraFeeRecalculatedPrice = model.extra_fee_recalculated_price;
			this.partNumber = model.part_number;
			this.brandLabel = model.brand_label;
			this.extraFeeStartingPrice = model.extra_fee_starting_price;
			this.extraFeeDiscountPercentage = model.extra_fee_discount_percentage;
			this.originalPartNumber = model.original_part_number;
			this.parent_id = model.parent_id;
			this.type = model.type;
			this.dealer_handler = model.dealer_handler;
			this.is_approved = model.is_approved;
			this.recharge_to = model.recharge_to;
			this.elapsedOrderIds = [];
			if (model.elapsed_order_ids) {
				model.elapsed_order_ids.forEach(id => {
					this.elapsedOrderIds.push(id);
				});
			}
			this.is_arrived_or_not_available = model.is_arrived_or_not_available;
			
			this.total_with_vat_assistance_center = model.total_with_vat_assistance_center;
			this.total_taxable_assistance_center = model.total_taxable_assistance_center;
		}
	}
	
	/**
	 * Converte un oggetto entry preventivo in un DTO
	 * @param {MechanicQuotationEntry} entry
	 * @returns {any}
	 */ 
	object2DTO(entry: MechanicQuotationEntry): any {
		return {
			accident_part_right 						 : entry.accidentPartRight,
			amount 													 : entry.amount,
			brand 													 : entry.brand,
			categorical 										 : entry.categorical,
			dealer_id 											 : entry.dealerId,
			description 										 : entry.description,
			discount 												 : entry.discount,
			discount_extra 									 : entry.discountExtra,
			entry_type 											 : entry.entryType,
			entry_status 										 : entry.entryStatus,
			frequency_handling 							 : entry.frequencyHandling,
			id 															 : entry.id,
			man_hour_hours 									 : entry.manHourHours,
			part_code 											 : entry.partCode,
			part_cost 											 : entry.partCost,
			part_id 												 : entry.partId,
			part_type 											 : entry.partType,
			rotation 												 : entry.rotation,
			total_part_value 								 : entry.totalPartValue,
			vat 														 : entry.vat,
			vat_free 												 : entry.vatFree,
			warranty_type 									 : entry.warrantyType,
			is_for_dealer 									 : entry.isForDealer,
			is_new 													 : entry.isNew,
			shipping_date 									 : entry.shippingDate,
			note 														 : entry.note,
			arrived_at 											 : entry.arrivedAt,
			is_for_consip 									 : entry.isForConsip,
			extra_fee_recalculated_price 		 : entry.extraFeeRecalculatedPrice,
			part_number 										 : entry.partNumber,
			brand_label 										 : entry.brandLabel,
			extra_fee_starting_price 				 : entry.extraFeeStartingPrice,
			extra_fee_discount_percentage 	 : entry.extraFeeDiscountPercentage,
			original_part_number 						 : entry.originalPartNumber,
			parent_id 											 : entry.parent_id,
			type 														 : entry.type,
			dealer_handler 									 : entry.dealer_handler,
			is_approved 										 : entry.is_approved,
			recharge_to 										 : entry.recharge_to,
			is_arrived_or_not_available 		 : entry.is_arrived_or_not_available,
			total_with_vat_assistance_center : entry.total_with_vat_assistance_center,
			total_taxable_assistance_center  : entry.total_taxable_assistance_center,
			elapsed_order_ids  							 : entry.elapsedOrderIds,
		};
	}
}

export class MechanicQuotationSummary {
	entries: SummaryQuotationEntry[];
	fixedConsumablesValue: string;
	total: QuotationSummaryTotal;
	totalHourManpower: string;
	extraFeeTotal: number;
	extraFeeTotalWithVat: number;
	extraFeeVatTax: number;
	extraFeeSparePartsTotal: number;
	carbodyHourlyManpowerMechanicCost: number;
	consumablesVeDoubleLayerThreshold: number;
	hourlyManpowerCost: number;
	taxableDiscountPercentage: number;
	vatQuotationPercentage: number;
	wasteDisposalPercentage: number;
	totalSparePartsTaxableAssistanceCenter: number;
	totalTaxableAssistanceCenter: number;
	totalVatAssistanceCenter: number;
	totalWithVatAssistanceCenter: number;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.entries = [];
			model.entries.forEach (item => this.entries.push (new SummaryQuotationEntry (item)));
			this.fixedConsumablesValue = model.fixed_consumables_value;
			this.total = new QuotationSummaryTotal (model.total);
			this.totalHourManpower = model.total_hour_manpower;
			this.extraFeeTotal = model.extra_fee_total;
			this.extraFeeTotalWithVat = model.extra_fee_total_with_vat;
			this.extraFeeVatTax = model.extra_fee_vat_tax;
			this.extraFeeSparePartsTotal = model.extra_fee_spare_parts_total;
			this.carbodyHourlyManpowerMechanicCost = model.carbody_hourly_manpower_mechanic_cost;
			this.consumablesVeDoubleLayerThreshold = model.consumables_ve_double_layer_threshold;
			this.hourlyManpowerCost = model.hourly_manpower_cost;
			this.taxableDiscountPercentage = model.taxable_discount_percentage;
			this.vatQuotationPercentage = model.vat_quotation_percentage;
			this.wasteDisposalPercentage = model.waste_disposal_percentage;
			this.totalSparePartsTaxableAssistanceCenter = model.total_spare_parts_taxable_assistance_center;
			this.totalVatAssistanceCenter = model.total_vat_assistance_center;
			this.totalTaxableAssistanceCenter = model.total_taxable_assistance_center;
			this.totalWithVatAssistanceCenter = model.total_with_vat_assistance_center;
		}
	}
	
	/**
	 * Converte un oggetto summary preventivo in un DTO
	 * @param {MechanicQuotationSummary} summary
	 * @returns {any}
	 */ 
	object2DTO(summary: MechanicQuotationSummary): any {

		return {
			fixed_consumables_value 								    : summary.fixedConsumablesValue,
			total_hour_manpower 										    : summary.totalHourManpower,
			extra_fee_total 												    : summary.extraFeeTotal,
			extra_fee_total_with_vat 									  : summary.extraFeeTotalWithVat,
			extra_fee_vat_tax 												  : summary.extraFeeVatTax,
			extra_fee_spare_parts_total 							  : summary.extraFeeSparePartsTotal,
			carbody_hourly_manpower_mechanic_cost 		  : summary.carbodyHourlyManpowerMechanicCost,
			consumables_ve_double_layer_threshold 		  : summary.consumablesVeDoubleLayerThreshold,
			hourly_manpower_cost 										    : summary.hourlyManpowerCost,
			taxable_discount_percentage 						    : summary.taxableDiscountPercentage,
			vat_quotation_percentage 								    : summary.vatQuotationPercentage,
			waste_disposal_percentage 							    : summary.wasteDisposalPercentage,
			total_spare_parts_taxable_assistance_center : summary.totalSparePartsTaxableAssistanceCenter,
			total_vat_assistance_center 							  : summary.totalVatAssistanceCenter,
			total_taxable_assistance_center 					  : summary.totalTaxableAssistanceCenter,
			total_with_vat_assistance_center 					  : summary.totalWithVatAssistanceCenter,
			
			total : summary.total.object2DTO(summary.total),
			entries : Utilities.isEmpty(summary.entries) ? [] : summary.entries.map((x: SummaryQuotationEntry) => x.object2DTO(x)),
		};
	}
}


// SHARED
class QuotationSummaryTotal {
	discountedTaxable: number;
	taxable: number;
	discount: number;
	total: number;
	totalWithVatFree: number;
	type: string;
	vat: number;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.discountedTaxable = model.discounted_taxable;
			this.taxable = model.taxable;
			this.discount = model.discount;
			this.total = model.total;
			this.totalWithVatFree = model.total_with_vat_free;
			this.type = model.type;
			this.vat = model.vat;
		}
	}

	/**
	 * Converte un oggetto summary totale in un DTO
	 * @param {QuotationSummaryTotal} total
	 * @returns {any}
	 */ 
	object2DTO(total: QuotationSummaryTotal): any {
		return {
			discounted_taxable 	: total.discountedTaxable,
			taxable 						: total.taxable,
			discount 						: total.discount,
			total 							: total.total,
			total_with_vat_free : total.totalWithVatFree,
			type 								: total.type,
			vat 								: total.vat,
		};
	}
}

export class SummaryQuotationEntry {
	taxable: number;
	total: number;
	type: string;
	vat: number;
	discount: number;

	constructor(model?: any) {
		if (!Utilities.isVoid (model)) {
			this.taxable = model.taxable;
			this.total = model.total;
			this.type = model.type;
			this.vat = model.vat;
			this.discount = model.discount;
		}
	}

	/**
	 * Converte un oggetto entry in un DTO
	 * @param {SummaryQuotationEntry} entry
	 * @returns {any}
	 */ 
	object2DTO(entry: SummaryQuotationEntry): any {
		return {
			taxable  : entry.taxable,
			total 	 : entry.total,
			type 		 : entry.type,
			vat 		 : entry.vat,
			discount : entry.discount,
		};
	}
}

export enum EQuotationStates {
	DRAFT   							  = 'DRAFT',
	TO_SEND   						  = 'TO_SEND',
	PRE_AUTHORITY_REJECTED  = 'PRE_AUTHORITY_REJECTED',
	TO_CHANNEL   					  = 'TO_CHANNEL',
	APPROVING   					  = 'APPROVING',
	DECLINED   						  = 'DECLINED',
	REJECTED   						  = 'REJECTED',
	WAITING_FOR_UNFREEZE    = 'WAITING_FOR_UNFREEZE',
	WAITING_FOR_ACCEPTANCE  = 'WAITING_FOR_ACCEPTANCE',
	SUPERVISOR_APPROVING    = 'SUPERVISOR_APPROVING',
	SUPERVISOR_REJECTED     = 'SUPERVISOR_REJECTED',
	WAITING_PARTS   			  = 'WAITING_PARTS',
	WAITING_FOR_REFRESH     = 'WAITING_FOR_REFRESH',
	RE_APPROVING   				  = 'RE_APPROVING',
	RE_DECLINED   				  = 'RE_DECLINED',
	C_FLOW_APPROVING   		  = 'C_FLOW_APPROVING',
	C_FLOW_REJECTED   		  = 'C_FLOW_REJECTED',
	WAITING_FOR_WORKING     = 'WAITING_FOR_WORKING',
	WORKING   						  = 'WORKING',
	INTEGRATION_TO_SEND     = 'INTEGRATION_TO_SEND',
	CLOSED_WITH_LIQUIDATION = 'CLOSED_WITH_LIQUIDATION',
	CLOSED_WITH_REJECTION   = 'CLOSED_WITH_REJECTION',
	CLOSED   							  = 'CLOSED'
}
